// NIGHT-DIRECTSTAFF-2026-10-17 §2: what the lead signed up for, in words, and whether texting is allowed.
// Field names from the agents window (10-17): job alerts are form_type 'job_alert' with raw_payload.alert_cadence
// ('daily' | 'weekly', mirrored as alert_frequency; missing = weekly); chat is form_type 'chat' with the page in
// leads.source_page (and raw_payload.source_page); consent is leads.sms_consent (false when unchecked) + sms_consent_at.
import { sourceKind } from './leadFilters';

const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
const raw = (l) => (l && l.raw_payload && typeof l.raw_payload === 'object' ? l.raw_payload : {});
const DASH = ' — ';

/** "traveltherapysalary.com" from "https://www.traveltherapysalary.com/x"; '' for "meta" or blank. */
export function siteHost(l) {
  const h = s(l && l.source_site).toLowerCase().replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/[/?#].*$/, '');
  return h && h !== 'meta' && h.includes('.') ? h : '';
}
/** "protherapystaffing.com/jobs/pt-denver…" -- the chat page without the scheme, cut to `max` characters. */
export function pageShort(url, max = 48) {
  const t = s(url).replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/[?#].*$/, '').replace(/\/$/, '');
  return t.length > max ? `${t.slice(0, max - 1)}…` : t;
}
/** 'daily' | 'weekly' (missing or anything else = weekly, the agents window's ruling). */
export function alertCadence(l) {
  const r = raw(l);
  const c = s(r.alert_cadence || r.alert_frequency).toLowerCase();
  return c === 'daily' ? 'daily' : 'weekly';
}

/** -> { kind, label, title } e.g. "Job alerts (weekly) — traveltherapysalary.com", "Chat — protherapystaffing.com/jobs/…" */
export function signedUpFor(l) {
  const host = siteHost(l);
  const on = (t) => (host ? `${t}${DASH}${host}` : t);
  const kind = sourceKind(l);
  const title = s(l && l.source_site);
  if (kind === 'alerts') return { kind, label: on(`Job alerts (${alertCadence(l)})`), title };
  if (kind === 'chat') {
    const page = pageShort((l && l.source_page) || raw(l).source_page);
    return { kind, label: page ? `Chat${DASH}${page}` : on('Chat'), title: s((l && l.source_page) || raw(l).source_page) || title };
  }
  if (kind === 'meta') return { kind, label: 'Meta ad', title };
  if (kind === 'job') return { kind, label: on('Job apply'), title };
  if (kind === 'voicemail') return { kind, label: 'Voicemail', title };
  if (kind === 'manual') return { kind, label: 'Added in the CRM', title };
  return { kind, label: on('Site form'), title };
}

const day = (iso) => {
  if (!iso) return '';   // new Date(null) is 1970, not "no date"
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
/**
 * Whether texting is allowed, at a glance -> { ok, text }.
 *   replied STOP          -> no  ("No texting: replied STOP")
 *   box checked (+ date)  -> yes ("Texting OK: consent box checked 2026-10-16")
 *   box not checked       -> no  ("No texting consent: box not checked")
 */
export function consentLine(l) {
  if (l && l.sms_opt_out) return { ok: false, text: 'No texting: replied STOP' };
  if (l && l.sms_consent === true) {
    const d = day(l.sms_consent_at);
    return { ok: true, text: `Texting OK: consent box checked${d ? ` ${d}` : ''}` };
  }
  return { ok: false, text: 'No texting consent: box not checked' };
}
